import { observer } from 'mobx-react';
import { PostMortemForm } from './PostMortemForm';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { StandardDialog } from '@roc/ui';
import { Document as DocumentType } from '@roc/feature-types';

export type PostMortemItemProps = {
  open: boolean;
  onClose: () => void;
  loanId?: string;
  document?: DocumentType;
};

export const PostMortemItem = observer(
  ({ open, onClose, loanId, document }: PostMortemItemProps) => {
    const dialogContent = (
      <PostMortemForm
        handleClose={onClose}
        loanId={loanId}
      />
    );

    return (
      <>
        {document?.taskId ? (
          <CustomTaskDialog
            open={open}
            title="Post-Mortem Comments"
            handleClose={onClose}
            dialogContent={dialogContent}
            taskId={document.taskId}
          />
        ) : (
          <StandardDialog
            open={open}
            title="Post-Mortem Comments"
            maxWidth="sm"
            handleClose={onClose}
            dialogContent={dialogContent}
          />
        )}
      </>
    );
  }
);

export default PostMortemItem;
